var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"copyright dimColor",attrs:{"id":"copyright"}},[_vm._v(" Fredrik Wendel. Copyright © 2011-"+_vm._s(_vm.currentYear())+" All rights reserved! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }